import { render } from "./LoginForm.vue?vue&type=template&id=028c1cce"
const script = {}

import exportComponent from "/home/circleci/repo/apps/photon/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__